import styled from "@emotion/styled"
import {
	breakpoint,
	spacingFluidLg,
	spacingFluidMd,
	spacingFluidSm,
} from "@porsche-design-system/components-react/emotion"
import { shouldForwardProp } from "src/common/shouldForwardProp"

export const FormLayoutGroup = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${spacingFluidMd};
	grid-column: 1;
`

// TODO: maybe extend by heading and subheading
export const FormLayout = styled("div", { shouldForwardProp })<{
	$width?: "half" | "quarter"
}>`
	display: grid;
	gap: ${spacingFluidSm} ${spacingFluidLg};

	@media (min-width: ${breakpoint.s}px) {
		grid-template-columns: ${({ $width }) => `repeat(${$width === "half" || $width === "quarter" ? 2 : 1}, minmax(0, 1fr))`};
	}

	@media (min-width: ${breakpoint.l}px) {
		grid-template-columns: ${({ $width }) => `repeat(${$width === "half" ? 2 : $width === "quarter" ? 4 : 1}, minmax(0, 1fr))`};
	}

	> * {
		grid-column: 1
	}
`
